/**
 * 売却査定フォーム
 *
 * 「その他」選択時にテキスト入力欄を表示する
 */
const assessment = () => {
    if (document.getElementById('page-assessment') === null) return;

    const OTHER_VALUE = 'other';

    /**
     * ラジオボタン：「その他」選択時に __other-text を表示
     */
    document.querySelectorAll('.c-forms-input-card-radio').forEach(group => {
        const radios = group.querySelectorAll('.c-forms-card-radio__input');
        const row = group.closest('.c-forms-row');
        const otherText = row?.querySelector('.pg-assessment-land__other-text');
        if (!otherText) return;

        const toggle = () => {
            const checked = group.querySelector('.c-forms-card-radio__input:checked');
            if (checked?.value === OTHER_VALUE) {
                otherText.setAttribute('data-active', '');
            } else {
                otherText.removeAttribute('data-active');
            }
        };

        radios.forEach(radio => radio.addEventListener('change', toggle));
        toggle();
    });

    /**
     * チェックボックス：「その他」チェック時に __other-text を表示
     */
    document.querySelectorAll('.c-forms-input-card-checkbox').forEach(group => {
        const checkboxes = group.querySelectorAll('.c-forms-card-checkbox__input');
        const row = group.closest('.c-forms-row');
        const otherText = row?.querySelector('.pg-assessment-land__other-text');
        if (!otherText) return;

        const toggle = () => {
            const otherCheckbox = group.querySelector(`.c-forms-card-checkbox__input[value="${OTHER_VALUE}"]`);
            if (otherCheckbox?.checked) {
                otherText.setAttribute('data-active', '');
            } else {
                otherText.removeAttribute('data-active');
            }
        };

        checkboxes.forEach(checkbox => checkbox.addEventListener('change', toggle));
        toggle();
    });
};

export default assessment;
